export const getTransmissionLabel = (value) => {
  if (value === 'automatic') return 'Automático';
  if (value === 'manual') return 'Manual';
  return 'Tanto faz';
};

export const getPaymentMethodLabel = (value) => {
  if (value === 'cash') return 'À vista';
  if (value === 'financing') return 'Financiamento';
  return 'Misto';
};

export const getUrgencyLabel = (value) => {
  if (value === 'imediato') return 'Imediato';
  if (value === '1mes') return '1 mês';
  if (value === '3meses') return '3 meses';
  return 'Sem pressa';
};

export const getTradeinText = (hasTradein, tradeinDetails) => {
  if (!hasTradein) return '- Não possui carro para troca';
  return `- Sim, possui carro para troca\n- Detalhes: ${tradeinDetails}`;
};

export const INITIAL_CAR_FORM_DATA = {
  name: '',
  email: '',
  phone: '',
  carType: '',
  brand: '',
  preferredModels: '',
  yearRange: '',
  maxKm: '',
  transmission: '',
  fuel: '',
  budget: '',
  paymentMethod: '',
  hasTradein: false,
  tradeinDetails: '',
  urgency: '',
  observations: ''
};
